/**
 * 路由变量配置
 */
export default {
    'means': resolve => require(['../components/page/means.vue'], resolve),
    'sysUser': resolve => require(['../components/page/sys-user.vue'], resolve),
    'sysLog': resolve => require(['../components/page/sys-log.vue'], resolve),
    'sysRole': resolve => require(['../components/page/sys-role.vue'], resolve),
    'department': resolve => require(['../components/page/department.vue'], resolve),
    'udUser': resolve => require(['../components/page/ud-user.vue'], resolve),
    'inviteUser': resolve => require(['../components/page/invite-user.vue'], resolve),
    'invite': resolve => require(['../components/page/invite.vue'], resolve),
    'order': resolve => require(['../components/page/order.vue'], resolve),
    'inviteUserList': resolve => require(['../components/page/invite-user-list.vue'], resolve),
    'inviteNet': resolve => require(['../components/page/invite-net.vue'], resolve),
    'inviteDesign': resolve => require(['../components/page/invite-design.vue'], resolve),
    'train': resolve => require(['../components/page/train.vue'], resolve),
    'sysMenu': resolve => require(['../components/page/sys-menu.vue'], resolve)
}
